export default "__VITE_ASSET__DVUOSCVC__"